module.exports = __webpack_public_path__ + "static/media/vincent_collin.bf2a9c4d.jpg";